import React from 'react';
import { frames } from '../../../Styles';
import PageHeader from '../../../Components/BaseComponents/pageHeader';
import { useTranslation } from 'react-i18next';

export default function ComponentAlternatives() {
  const { t } = useTranslation();

  return (
    <frames.Page_inner>
    <frames._page_inner_header>
      <PageHeader topHeader={t("globalMenu.feedCurves")} subHeader={t("globalMenu.ComponentAlternatives")}/>
    </frames._page_inner_header>
    <frames._page_inner_content>
    </frames._page_inner_content>
    </frames.Page_inner>
  );
}